/** Append JWT for media URLs loaded via <img>/<video>/<audio> (no Authorization header). */

export function getStorycraftToken() {
  try {
    return localStorage.getItem('storycraft_token') || '';
  } catch {
    return '';
  }
}

function needsAccessToken(pathnameOrUrl) {
  const s = String(pathnameOrUrl || '');
  return (
    s.includes('/api/avatar-cast/')
    || s.includes('/api/mock_s3/')
    || s.includes('/api/storage/local/')
  );
}

export function withAccessToken(url, token = getStorycraftToken()) {
  const raw = String(url || '').trim();
  if (!raw || !token) return raw;
  if (!needsAccessToken(raw)) {
    return raw;
  }
  try {
    const abs = raw.startsWith('http')
      ? new URL(raw)
      : new URL(raw, typeof window !== 'undefined' ? window.location.origin : 'http://localhost');
    if (!needsAccessToken(abs.pathname)) {
      return raw;
    }
    if (!abs.searchParams.get('access_token') && !abs.searchParams.get('token')) {
      abs.searchParams.set('access_token', token);
    }
    if (raw.startsWith('http')) return abs.toString();
    return `${abs.pathname}${abs.search}${abs.hash}`;
  } catch {
    const join = raw.includes('?') ? '&' : '?';
    return `${raw}${join}access_token=${encodeURIComponent(token)}`;
  }
}
